import React, { Component } from 'react'
import {get} from 'lodash'
import { connect } from "react-redux"
import { Button } from 'react-weui'

import Page from '../components/FixedBarPage'
import { getSelections, getCity } from '../selectors'


export default class ReservationPage extends Component {

  constructor(props) {
    super(props)
    this.state = { enable: true }
  }

  componentDidMount() {
    setTimeout(() => { this.setState({enable: false}) }, 6000)
  }
  
  render() {
    
    return (
      <Page
        title="足球"
        containerStyle={{ display: 'flex', flexGrow: 1 }}
      >
        <div className="weui-msg success" style={{ margin: "auto" }}>
          <div className="weui-msg__icon-area">
            <i className="weui-icon-success weui-icon_msg" />
          </div>
          <div className="weui-msg__text-area">
            <h2 className="weui-msg__title">谢谢！</h2>
            <p className="weui-msg__desc">
              <p className="weui-msg__desc">我们会尽快与您联系</p>
              <br />
              <p className="weui-msg__desc">足球赛季将于8月18日重新开始</p>
              <br />
              <p className="weui-msg__desc">我们会在此之前通知您😉 </p>
            </p>
          </div>
          <div className="weui-msg__opr-area">
            <p className="weui-btn-area">
              <a href="/catalogo" className="weui-btn weui-btn_primary">返回首页</a>
            </p>
          </div>
          <div className="weui-msg__extra-area">
            <div className="weui-footer">
              <p className="weui-footer__links">
                <a href="http://chinespain.cn" className="weui-footer__link">http://chinespain.cn</a>
              </p>
              <p className="weui-footer__text">©2018 APPROACHING CULTURES SL.</p>
            </div>
          </div>
        </div>
      </Page>
    )
  }

}
/**/



// WEBPACK FOOTER //
// ./src/app/catalogo/futbol/ConfirmationPage.jsx